import { render, staticRenderFns } from "./Swatches.vue?vue&type=template&id=2c52e145&scoped=true"
import script from "./Swatches.vue?vue&type=script&lang=js"
export * from "./Swatches.vue?vue&type=script&lang=js"
import style0 from "./Swatches.vue?vue&type=style&index=0&id=2c52e145&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c52e145",
  null
  
)

export default component.exports